import React from "react";
import styled from "@emotion/styled";
import { Card } from "antd";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import StarRating from "@components/item/StarRating";

const Container = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "1.2rem",
  padding: "2rem",
  borderBottom: `1px solid ${theme.color.border_gray}`,

  ".desc": {
    fontSize: "1.4rem",
  },
}));

const TitleWrapper = styled.div(({ theme }) => ({
  display: "flex",
  gap: "1.8rem",
  fontWeight: theme.fontWeight.medium,
  lineHeight: "1.6rem",
  paddingBottom: "0.8rem",

  ".time": {
    color: theme.color.light_gray,
    fontSize: "1.2rem",
    lineHeight: "1.2rem",
  },
}));

const ProductWrapper = styled.div(({ theme }) => ({
  display: "flex",
  gap: "1.6rem",
  alignItems: "flex-start",

  ".brand_name": {
    fontWeight: theme.fontWeight.semiBold,
    fontSize: "1.4rem",
  },

  ".product_name": {},
}));

const TextBox = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "0,4rem",
});

type Props = {
  nickname: string;
  product_image: string;
  product_name_ko: string;
  product_name_en: string;
  rate: number;
  product_total_count: number;
  created_at: string;
  review_text: string;
};
const ReviewCard = ({
  nickname,
  product_image,
  product_name_ko,
  product_name_en,
  rate,
  product_total_count,
  created_at,
  review_text,
}: Props) => {
  const theme = useTheme();
  const language = localStorage.getItem("language");

  const handleNavigateDetailPage = () => {};

  return (
    <Container>
      <TitleWrapper>
        <span>{nickname}</span>
        <span className="time">{created_at}</span>
      </TitleWrapper>

      <ProductWrapper>
        <Image
          src={product_image ? product_image : theme.image.default}
          width="6rem"
          height="6rem"
        />

        <TextBox>
          <span>
            {language === "en" && product_name_en !== ""
              ? product_name_en
              : product_name_ko}{" "}
            {product_total_count !== 1 && `외 ${product_total_count - 1}건`}
          </span>
        </TextBox>
      </ProductWrapper>

      <StarRating rate={rate} readonly />

      <span className="ellipsis-2 desc">{review_text}</span>
    </Container>
  );
};

export default ReviewCard;
